module.exports = __webpack_public_path__ + "img/activate-gradient.1913e1ff.png";